import { render, staticRenderFns } from "./DataDownload.vue?vue&type=template&id=f64e24fc&"
import script from "./DataDownload.vue?vue&type=script&lang=js&"
export * from "./DataDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64e24fc')) {
      api.createRecord('f64e24fc', component.options)
    } else {
      api.reload('f64e24fc', component.options)
    }
    module.hot.accept("./DataDownload.vue?vue&type=template&id=f64e24fc&", function () {
      api.rerender('f64e24fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataDownload.vue"
export default component.exports